/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/07/14 08:37
 * @update 2026/07/14 08:37
 */

import Api from "../../../services/api";

export function loadGrid(params, cb) {
    return async () => {
        await Api.put('/w07f6699/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
